import util from '../../util.js';
import {minus_plus, text_bg_set} from '../../const.js';

let TUtil = {};
let getCssStyle = function (cssText) {
    let map = {};
    if (cssText) {
        let arr = cssText.split(';'), keyValueArray = null, key, value;
        arr.forEach((str) => {
            keyValueArray = str.split(':');
            key = keyValueArray[0].trim();
            value = keyValueArray[1];
            if (key) {
                map[key] = value.trim();
            }
        });
    }
    return map;
};
TUtil.getDefaultCss = function (parentCssMap) {
    return {
        'color': parentCssMap.color,
        'font-weight': parentCssMap.fontWeight,
        'font-size': parentCssMap.fontSize,
        'font-family': parentCssMap.fontFamily,
        'text-align': parentCssMap.textAlign,
        'text-shadow': parentCssMap.textShadow,
    };
}

function getCss(dom) {
    if (dom.nodeType === 3) {
        dom = dom.parentNode;
    }
    if (dom.style && dom.style.cssText) {
        return dom.style.cssText;
    } else if (dom.firstElementChild && dom.firstElementChild.nodeType !== 3) {
        return dom.firstElementChild.style.cssText;
    }
    return null
}

TUtil.getNodeCssText = function (dom) {
    let cssText = null;
    if (dom.tagName && dom.tagName.toLowerCase() === 'font') {
        cssText = `color: ${dom.color}`;
    } else {
        cssText = getCss(dom);
    }
    let cssMap = cssText ? getCssStyle(cssText) : null;
    let map = null;
    if (dom.parentNode && dom.parentNode.style) {
        map = this.getDefaultCss(dom.parentNode.style);
    }
    return {
        ...map, ...cssMap
    };
};
let getNumForPx = function (heightPx) {
    if (heightPx && heightPx.indexOf('px') > -1) {
        return heightPx.replace('px', '');
    } else {
        return null;
    }
}
TUtil.getTextBg = function (itemNode) {
    let textBgDom = itemNode.lastElementChild;
    if (textBgDom && textBgDom.className.indexOf('text-bg') > -1) {
        let map = getCssStyle(textBgDom.style.cssText);
        return {
            color: map['background-color'],
            height: getNumForPx(map.height),
            bottom: getNumForPx(map.bottom),
        }
    } else {
        return {};
    }
}
TUtil.toggleStyleAtrr = function (vue, listItem, key, value) {
    listItem.key = new Date().getTime();
    if (key === 'textBg') {
        vue.$set(listItem, 'textBg', value);
        return;
    }
    if (listItem.style[key] === value) {
        listItem.style[key] = null;
    } else {
        vue.$set(listItem.style, key, value);
    }
};
TUtil.deepUpdateId = function (children, parentId) {
    children.forEach((item, i) => {
        item.id = parentId + '_' + (i + 1);
        item.parentId = parentId;
        if (item.children) {
            this.deepUpdateId(item.children, item.id);
        }
    });
};
/**
 * @param newDataList
 * @param index
 * @param defaultItem  默认选项，如果有 则直接复制该项，如果没有 则使用index值
 * @returns {any}
 */
TUtil.copyItem = function (newDataList, index, defaultItem) {
    let newItem = null;
    if (defaultItem) {
        newItem = JSON.parse(JSON.stringify(defaultItem));
    } else {
        newItem = JSON.parse(JSON.stringify(newDataList[index]));
    }
    //找出最大Id
    let maxId = 0, maxIndex = null;
    newDataList.forEach((item, i) => {
        let arr = item.id.split('_');
        let id = parseInt(arr[arr.length - 1]);
        if (id > maxId) {
            maxId = id;
            maxIndex = i;
        }
    });
    //在最大id值的基础上 添加新id,保证id不会重复
    let parentId = newDataList[maxIndex].parentId;
    newItem.id = parentId + '_' + (maxId + 1);
    if (newItem.children) {
        this.deepUpdateId(newItem.children, newItem.id);
    }
    newItem.key = util.getUUID();
    return newItem;
};
TUtil.getIdList = function (idStr) {
    let arr = [idStr];
    while (idStr.indexOf('_') > -1) {
        idStr = idStr.substring(0, idStr.lastIndexOf('_'));
        arr.push(idStr);
    }
    return arr;
}
TUtil.getChildrenById = function (parent, children, id, callback) {
    children.forEach((item) => {
        if (item.id === id) {
            callback(children, parent);
            return;
        } else if (item.children) {
            this.getChildrenById(item, item.children, id, callback);
        }
    });
};
TUtil.moveItem = function (editorObj, focusItem, minusOrPlus, height) {
    /**
     * 获取当前焦点元素上的所有父元素，父元素位置肯定比当前元素位置高
     * 但其中某些子元素位置要低,找出这些子元素，并移动位置
     */
    let ids = this.getIdList(focusItem.id);
    ids.forEach((id) => {
        this.getChildrenById(editorObj, editorObj.children, id, (children, parent) => {
            if (parent.children) { // 当前元素的父元素高度要增加
                if (minusOrPlus === minus_plus.plus) {
                    plusHeightValue(parent, height);
                } else {
                    minusHeightValue(parent, height);
                }
            }
            let idx = children.findIndex((item) => {
                return item.id === id;
            });
            this.changeTopForOtherItem(children, idx, height, minusOrPlus, focusItem);
        });
    })
    if (!focusItem.isMoreRow && !focusItem.originHeight) {
        // 单行文本 line-height 使用的是 height的高度, 高度增加时，需要记录height值
        focusItem.originHeight = focusItem.height;
    }
    if (minusOrPlus === minus_plus.plus) {
        if (!focusItem.isMoreRow) { //单行文本变多行时，使用多行标签，行高用默认高度值
            focusItem.isMoreRow = true;
            focusItem.lineHeight = focusItem.height;
        }
        plusHeightValue(focusItem, height);
    } else {
        minusHeightValue(focusItem, height);
    }
}
const plusHeightValue = function (item, height) {
    item.height = +item.height + height;
    item.bottom = +item.bottom + height;
}
const minusHeightValue = function (item, height) {
    item.height = +item.height - height;
    item.bottom = +item.bottom - height;
}
const plusValue = function (item, spaceBetween) {
    item.top = +item.top + spaceBetween;
    item.bottom = +item.bottom + spaceBetween;
}
const minusValue = function (item, spaceBetween) {
    item.top = +item.top - spaceBetween;
    item.bottom = +item.bottom - spaceBetween;
}
const changeTopForBgMaterialImg = function (moduleItem, spaceBetween, minusOrPlus) {
    moduleItem.children && moduleItem.children.forEach((item) => {
        if (item.isBgMaterialImg) {
            if (minus_plus.plus === minusOrPlus) {
                plusValue(item, spaceBetween, true)
            } else {
                minusValue(item, spaceBetween, true);
            }
        }
    });
}
TUtil.changeTopForOtherItem = function (newDataList, startIndex, spaceBetween, minusOrPlus, focusItem) {
    if (startIndex < 0) {
        return;
    }
    let item = null, focusTop = +focusItem.top;
    let currentItem = newDataList[startIndex]; // 焦点元素的某一个父元素,该元素不需要做移动，只比较里面的子元素
    for (let i = 0; i < newDataList.length; i++) {
        item = newDataList[i];
        if (item.fixed) { // 任何时候都禁止不动
            continue;
        }
        if (+item.top < +focusItem.bottom && +item.top > +focusItem.top) { //焦点元素中间的元素不做移动
            continue;
        }
        if (item.isModuleGroup) {
            changeTopForBgMaterialImg(item, spaceBetween, minusOrPlus);
        }
        if (item.isBgMaterialImg) { // 当前是“背景元素”不做处理，由changeTopForBgMaterialImg处理
            continue;
        }
        if (+item.top > focusTop && item !== currentItem) {
            if (minus_plus.plus === minusOrPlus) {
                plusValue(item, spaceBetween)
            } else {
                minusValue(item, spaceBetween)
            }
            item.children && this.changeChildrenTop(item.children, spaceBetween, minusOrPlus, focusItem);
        }
    }
}
TUtil.changeChildrenTop = function (children, spaceBetween, minusOrPlus, focusItem) {
    let currentTop = +focusItem.top;
    children.forEach((item) => {
        if (item.fixed || item.isBgMaterialImg) {
            /**
             *  1、固定的元素不做移动
             *  2、背景素材不在此处 处理由 changeTopForBgMaterialImg 处理
             */
            return;
        }
        if (+item.top < +focusItem.bottom && +item.top > +focusItem.top) { //焦点元素中间的元素不做移动
            return;
        }
        if (item.isModuleGroup) {
            changeTopForBgMaterialImg(item, spaceBetween, minusOrPlus);
        }
        if (minus_plus.plus === minusOrPlus && +item.top > currentTop) {
            plusValue(item, spaceBetween)
        } else if (+item.top > currentTop) {
            minusValue(item, spaceBetween);
        }
        if (item.children) {
            this.changeChildrenTop(item.children, spaceBetween, minusOrPlus, focusItem);
        }
    })
}
TUtil.getTextStyle = function (textDom) {
    let children = textDom.childNodes;
    let itemNode = null, text, cssTextMap, dataList = [];
    for (let i = 0; i < children.length; i++) {
        itemNode = children[i];
        text = itemNode.textContent;
        if (text) {
            cssTextMap = TUtil.getNodeCssText(itemNode);
            dataList.push({
                key: util.getUUID(),
                text: text,
                textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                style: {...cssTextMap}
            });
        }
    }
    return dataList;
}
TUtil.getSelectionRangeData = function (vue, selection, textDom, text_bg_set, key, value) {
    let listItem = null;
    let range = selection.getRangeAt(0);
    let startNode = range.startContainer.parentNode;
    let endNode = range.endContainer.parentNode;
    let children = textDom.children;
    let startOffset = range.startOffset;
    let endOffset = range.endOffset;
    let itemNode = null;
    let startIndex = null;
    let endIndex = null;

    if (children.length === 1 && children[0].childNodes.length > 1) {
        // 进行换行时，文本节点会增加，这时选中文本是多个节点
        children = children[0].childNodes;
        startNode = children[0];
        endNode = children[children.length - 1];
    }
    for (let i = 0; i < children.length; i++) {
        itemNode = children[i];
        if (startNode === itemNode) {
            startIndex = i;
        }
        if (endNode === itemNode) {
            endIndex = i;
            break;
        }
    }
    let text = null, dataList = [], cssTextMap = null;
    for (let i = 0; i < children.length; i++) {
        itemNode = children[i];
        text = itemNode.textContent;
        cssTextMap = TUtil.getNodeCssText(itemNode);
        if (startNode === endNode && startNode === itemNode) {
            let preText = text.substring(0, startOffset);
            let selectionText = text.substring(startOffset, endOffset);
            let sufText = itemNode.textContent.substring(endOffset, text.length);
            if (preText) {
                listItem = {
                    key: `1_${i}`,
                    text: preText,
                    textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                    style: {...cssTextMap},
                    // color: itemNode.style.color,
                }
                dataList.push(listItem);
            }
            if (selectionText) {
                listItem = {
                    key: `12_${i}`,
                    isSelectionNode: true,
                    text: selectionText,
                    textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                    style: {...cssTextMap},
                };
                TUtil.toggleStyleAtrr(vue, listItem, key, value);
                dataList.push(listItem);
            }
            if (sufText) {
                dataList.push({
                    key: `3_${i}`,
                    text: sufText,
                    textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                    style: {...cssTextMap}
                });
            }
            continue;
        }
        if (startNode === itemNode) {
            let startText = text.substring(0, startOffset);
            if (startText) { //选中当前节点的部分文本
                dataList.push({
                    key: `4_${i}`,
                    text: startText,
                    textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                    style: {...cssTextMap},
                });
                listItem = {
                    key: `5_${i}`,
                    isSelectionNode: true,
                    text: text.substring(startOffset, itemNode.textContent.length),
                    textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                    style: {...cssTextMap},
                }
                TUtil.toggleStyleAtrr(vue, listItem, key, value);
                dataList.push(listItem);
            } else { //选中当前节点的所有文本
                listItem = {
                    key: `6_${i}`,
                    isSelectionNode: true,
                    text: text,
                    textBg: Object.assign({}, text_bg_set),
                    style: {...cssTextMap},
                }
                TUtil.toggleStyleAtrr(vue, listItem, key, value);
                dataList.push(listItem);
            }
        }
        if (endNode === itemNode) {
            let item = dataList.filter((o) => {
                return o.isSelectionNode
            })[0];
            if (text.length === endOffset) {
                //选中结尾节点全部内容
                item.text += text;
            } else {//选中结尾节点部分内容
                item.text += text.substring(0, endOffset);
                dataList.push({
                    key: `7_${i}`,
                    text: text.substring(endOffset, text.length),
                    textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                    style: {...cssTextMap},
                });
            }
        }
        if (i > startIndex && i < endIndex) {
            let item = dataList.filter((o) => {
                return o.isSelectionNode
            })[0];
            item.text += text;
        } else if (endNode !== itemNode && startNode !== itemNode) {
            dataList.push({
                key: `8_${i}`,
                text: text,
                textBg: Object.assign({}, text_bg_set, TUtil.getTextBg(itemNode)),
                style: {...cssTextMap},
            });
        }
    }
    return dataList;
}
/**
 * banner添加树结构，添加children属性用来显示树结构，编辑时，将json.children转成data操作
 * @reverse 倒序，越上面的元素，越显示在最上层(后调整的数据结构和ps顺序保持一致)
 * @param children 树结构
 * @param data 平行数组
 */
TUtil.copyChildrenToData = function (reverse, children, data) {
    if (!reverse) {
        children.reverse();
    }
    children.forEach((item) => {
        if (item.children) {
            if(item.type === 'group'){ // 自由模板分配分组id
                let dataList = [];
                setGroupData(item, dataList);
                item.groupId = util.getUUID();
                dataList.forEach((c) => {
                    c.parentGroupId = item.groupId;
                });
                item.children = dataList;
                if (!reverse) {
                    item.children.reverse();
                }
                data.push(item);
            }else{
                this.copyChildrenToData(reverse, item.children, data)
            }
        } else if (item.type) { // 过滤文本和图片图层
            item.originData = {
                left: item.left,
                top: item.top,
                height: item.height,
                width: item.width
            }
            data.push(item);
        }
    });
}
const setGroupData = function(group, dataList){
    group.children.forEach((item) => {
        if(item.children){
           setGroupData(item, dataList);
        }else{
            dataList.push(item);
        }
    });
}
const updateZindex = function (dataList) {
    let len = dataList.length;
    dataList.forEach((item, index) => {
        item.zIndex = len - index;
    });
    dataList.reverse();
    return dataList;
}
/**
 * 原banner中的data是普通数组对象，后来需要树形结构
 * 此处将树形结构转成普通数组，兼容老模板数据
 * @param templateObj 模板数据
 */
TUtil.formatterChildrenToDataAttr = function (templateObj) {
    // 将树形数据转成数组
    let json = templateObj.json;
    if (json.children && !json.data) {
        let newArray = [];
        TUtil.copyChildrenToData(json.reverse, json.children, newArray);
        json.reverse = true;
        templateObj.json.data = updateZindex(newArray);
    }
}
TUtil.formatterChildren = function(templateObj){
    // 将树形数据转成数组,针对自由模板兼容图文和banner数据
    let json = templateObj.json;
    if (json.children) {
        let newArray = [];
        TUtil.copyChildrenToData(json.reverse, json.children, newArray);
        json.reverse = true;
        templateObj.json.children = newArray
    }else if(json.data){
        templateObj.json.children = json.data;
        delete templateObj.data;
    }
}
TUtil.copyDataToChildren = function (templateObj) {
    //老数据，只有data属性，将data数据复制到children
    let json = templateObj.json;
    let dataList = templateObj.json.data;
    if (!json.children && dataList) {
        json.data.forEach((item, index) => {
            if (!item.key) { //补充key属性
                item.key = util.getUUID();
            }
            if (!item.id) { //补充id属性
                item.id = index + 1;
            }
            if (item.zIndex === undefined) {
                item.zIndex = index + 1;
            }
            if(item.isBgImg && index === 0){ // 老的banner，使用isBgImg做为背景，现成统一成isPageBgImg
                item.isPageBgImg = true;
            }
        })
        json.children = dataList;
        delete json.data;
    }
    return templateObj;
}
const setWidth = function (domRef) {
    let widthArr = domRef.querySelectorAll('table td');
    let width, fontSize;
    for (let i = 0; i < widthArr.length; i++) {
        width = widthArr[i].style.width;
        if (width.indexOf('pt') > -1) {
            width = +width.split('pt')[0];
            widthArr[i].style.width = width * (4 / 3) + 'px';
        }
    }
    let fontSizeArr = domRef.querySelectorAll('table span');
    for (let i = 0; i < fontSizeArr.length; i++) {
        fontSize = fontSizeArr[i].style.fontSize;
        if (fontSize.indexOf('pt') > -1) {
            fontSize = +fontSize.split('pt')[0];
            fontSizeArr[i].style.fontSize = fontSize * (4 / 3) + 'px';
        }
    }
}
TUtil.tableToImg = function (vueObj, htmlStr) {
    return new Promise((function (resolve, reject) {
        setTimeout(function () {
            if (htmlStr.indexOf('pt;') > -1) {
                setWidth(vueObj.$refs.wordImgRef.$el);
            }
            vueObj.$refs.wordImgRef._getImg().then(({url, height}) => {
                resolve({url: url, htmlStr: htmlStr, height});
            }).catch(() => {
                reject();
            })
        }.bind(this), 100);
    }));
}
TUtil.getEmptyBgData = function(){
    return {
        top: 0,
        left: 0,
        width: null,
        height: null,
        bottom: null,
        backgroundColor: null,
        showImg: true,
        isBgImg: true,
        isPageBgImg: true,
        originName: '背景',
        name: '背景',
        type: 'img',
        isGroupMaterial: false,
        zIndex: 0,
        url: '',
    }
}
TUtil.beforeUploadBg = function(file){
    if (file.type.indexOf('image') > -1) {
        return true;
    } else {
        return false;
    }
}
TUtil.uploadSuccessBg = function(response){
    if (response.code === 200) {
        let {url, properties} = response.result;
        let arr = properties.split('x');
        let w = arr[0], h = arr[1];
        return {
            width: w, height: h, url: url
        }
    }else{
        return null;
    }
}
const getLetterSpacing = function(letterSpacing) {
    if (!letterSpacing || letterSpacing === 'normal') {
        return null;
    }
    if (isNaN(letterSpacing) && letterSpacing.indexOf('px') > -1) {
        letterSpacing = letterSpacing.split('px')[0];
    }
    return parseFloat(letterSpacing);
}
TUtil.fixWidth = function(item){
    let letterSpacing = getLetterSpacing(item.letterSpacing);
    if (letterSpacing) { // 有字符间距时，宽度偏小, 老数据width值是字符
        item.width = (+item.width) + letterSpacing + 5;
    } else {
        item.width = (+item.width) + Math.ceil(item.fontSize / 10);
    }
    item.right = (+item.left) + (+item.width);
}
TUtil.fixAttr = function(item){ //ps字体解析到浏览器上时，宽度有偏差，这里做部分修复
    if(item.alreadyFixed || item.type !== 'text'){
        return;
    }
    if (item.scale && item.scale.toString().indexOf(',') > -1) {
        let scaleW = parseFloat(item.scale.split(',')[0]);
        item.fontSize = parseInt(scaleW * item.fontSize);
        item.scale = null;
    }
    //ps中的行高大多数设置得不对，此处转换下，兼容老模板
    let lh = item.lineHeight;
    if(lh === 0 || !item.isMoreRow){
        item.lineHeight = item.fontSize;
    }
    TUtil.fixWidth(item);
    item.alreadyFixed = true;
}
TUtil.updateGroupItemRatio = function(groupItem){
    groupItem.children.forEach((item) => {
        item.leftRatio = parseFloat(((item.left -  groupItem.left)/ groupItem.width).toFixed(3));
        item.topRatio = parseFloat(((item.top - groupItem.top) / groupItem.height).toFixed(3));
    });
};
const sortNumber = function(a, b) {
    return a - b;
}
TUtil.getGroupPositionByLayers = function(layers){
    let leftArr = [], topArr = [], bottomArr = [], rightArr = [], textScale;
    layers.forEach((item) => {
        textScale = item.scale || 1;
        leftArr.push(+item.left);
        topArr.push(+item.top);
        rightArr.push(+item.left + (+item.width * textScale));
        bottomArr.push(+item.top + (+item.height * textScale));
    });
    leftArr.sort(sortNumber);
    topArr.sort(sortNumber);
    rightArr.sort(sortNumber);
    bottomArr.sort(sortNumber);
    let groupItem = {
        left: leftArr[0],
        top: topArr[0],
        right: rightArr[rightArr.length - 1],
        bottom: bottomArr[bottomArr.length - 1]
    };
    groupItem.height = groupItem.bottom - groupItem.top;
    groupItem.width = groupItem.right - groupItem.left;
    return groupItem;
}
export default TUtil;